import { CreateTargetService } from "../services/CreateTargetService";

export const CreateTargetAction = {
    getAllRegions,
    getStateDDL,
    getDistrictDDL,
    getTownDDL,
    getAllProductList,
    submitProductTarget,
    submitCategoryTarget,
    getAllCategory,
    getProductTargetData,
    getCategoryTargetData
};

function getAllRegions() {
    return (dispatch) => {
        dispatch({ type: "FETCH_REGIONS_REQUEST" });
        return CreateTargetService.GetRegionDll()
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedRegions = response.ResponseData.map(item => ({
                        label: item.label,
                        value: item.value
                    }));
                    dispatch({ type: "FETCH_REGIONS_SUCCESS", payload: formattedRegions });
                    return formattedRegions;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load regions");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_REGIONS_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getAllProductList() {
    return (dispatch) => {
        dispatch({ type: "FETCH_PRODUCTS_REQUEST" });
        return CreateTargetService.getAllProductList()
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedProducts = response.ResponseData.map(item => ({
                        ProductName: item.ProductName,
                        ProductId: item.ProductId
                    }));
                    dispatch({ type: "FETCH_PRODUCTS_SUCCESS", payload: formattedProducts });
                    return formattedProducts;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load products");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_PRODUCTS_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getStateDDL(regionId) {
    return (dispatch) => {
        dispatch({ type: "FETCH_STATES_REQUEST" });
        return CreateTargetService.getStateDDL(regionId)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedStates = response.ResponseData.map(item => ({
                        label: item.StateName || item.label || 'Unknown',
                        value: item.StateId || item.value || item
                    }));
                    dispatch({ type: "FETCH_STATES_SUCCESS", payload: formattedStates });
                    return formattedStates;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load states");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_STATES_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getDistrictDDL(stateId) {
    return (dispatch) => {
        dispatch({ type: "FETCH_DISTRICTS_REQUEST" });
        return CreateTargetService.getDistrictDDL(stateId)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedDistricts = response.ResponseData.map(item => ({
                        label: item.DistrictName || item.label || 'Unknown',
                        value: item.DistrictId || item.value || item
                    }));
                    dispatch({ type: "FETCH_DISTRICTS_SUCCESS", payload: formattedDistricts });
                    return formattedDistricts;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load districts");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_DISTRICTS_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getTownDDL(districtId) {
    return (dispatch) => {
        dispatch({ type: "FETCH_TOWNS_REQUEST" });
        return CreateTargetService.getTownDDL(districtId)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedTowns = response.ResponseData.map(item => ({
                        label: item.TownName || item.label || 'Unknown',
                        value: item.TownId || item.value || item
                    }));
                    dispatch({ type: "FETCH_TOWNS_SUCCESS", payload: formattedTowns });
                    return formattedTowns;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load towns");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_TOWNS_FAILURE", error: error.message });
                throw error;
            });
    };
}

function submitProductTarget(targetData) {
    return (dispatch) => {
        dispatch({ type: "SUBMIT_PRODUCT_TARGET_REQUEST" });
        return CreateTargetService.CreateProductTarget(targetData)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    dispatch({ type: "SUBMIT_PRODUCT_TARGET_SUCCESS", payload: response.ResponseData });
                    return response;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to submit target");
                }
            })
            .catch((error) => {
                dispatch({ type: "SUBMIT_PRODUCT_TARGET_FAILURE", error: error.message });
                throw error;
            });
    };
}

function submitCategoryTarget(targetData) {
    return (dispatch) => {
        dispatch({ type: "SUBMIT_CATEGORY_TARGET_REQUEST" });
        return CreateTargetService.CreateCategoryTarget(targetData)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    dispatch({ type: "SUBMIT_CATEGORY_TARGET_SUCCESS", payload: response.ResponseData });
                    return response;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to submit target");
                }
            })
            .catch((error) => {
                dispatch({ type: "SUBMIT_CATEGORY_TARGET_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getAllCategory() {
    return (dispatch) => {
        dispatch({ type: "FETCH_CATEGORIES_REQUEST" });
        return CreateTargetService.getCategoryDDL()
            .then((response) => {
                if (response.ResponseCode === "200") {
                    const formattedCategories = response.ResponseData.map(item => ({
                        label: item.label,
                        value: item.value
                    }));
                    dispatch({ type: "FETCH_CATEGORIES_SUCCESS", payload: formattedCategories });
                    return formattedCategories;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load categories");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_CATEGORIES_FAILURE", error: error.message });
                throw error;
            });
    };
}

function getProductTargetData(request = { search: "", pageNumber: 1, pageSize: 10 }) {
    return (dispatch) => {
        dispatch({ type: "FETCH_PRODUCT_TARGET_REQUEST" });
        return CreateTargetService.getProductTargetData(request)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    dispatch({ type: "FETCH_PRODUCT_TARGET_SUCCESS", payload: response.ResponseData });
                    return response;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load product target data");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_PRODUCT_TARGET_FAILURE", error: error.message });
                throw error;
            });
    };
}
function getCategoryTargetData(request = { search: "", pageNumber: 1, pageSize: 10 }) {
    return (dispatch) => {
        dispatch({ type: "FETCH_PRODUCT_TARGET_REQUEST" });
        return CreateTargetService.getCategoryTargetData(request)
            .then((response) => {
                if (response.ResponseCode === "200") {
                    dispatch({ type: "FETCH_PRODUCT_TARGET_SUCCESS", payload: response.ResponseData });
                    return response;
                } else {
                    throw new Error(response.ResponseMessage || "Failed to load product target data");
                }
            })
            .catch((error) => {
                dispatch({ type: "FETCH_PRODUCT_TARGET_FAILURE", error: error.message });
                throw error;
            });
    };
}